import BaseException from "exceptions/BaseException";

export default class InvalidTableGridModeException extends BaseException {
    readonly name = 'InvalidTableGridModeException';
}
